import { render } from "./VoteForm.vue?vue&type=template&id=72184ece"
import script from "./VoteForm.vue?vue&type=script&lang=js"
export * from "./VoteForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__